import { ReactNode } from 'react';
import { Box, Card, Divider, Stack, Text } from '@mantine/core';
import styled from '@emotion/styled';
import { de } from 'date-fns/locale';

interface INotificationContentProps {
    title: string;
    description: string;
    children: ReactNode;
}
export function NotificationContent({ title, description, children }: INotificationContentProps) {
    return (
        <Card shadow="xs" p={0} radius="xs" color="gray.1" sx={{ overflow: 'visible' }}>
            <Stack spacing={0}>
                <Box p="md">
                    <Text size={16}>{title}</Text>
                    <NotificationDescription description={description} />
                </Box>
                <Divider color="gray.3" />
                <Box p="md">{children}</Box>
            </Stack>
        </Card>
    );
}

export function NotificationDescription({ description }: { description?: null | string }) {
    return (
        <>
            {!description ? null : (
                <Text sx={{ whiteSpace: 'pre-wrap' }} size={13}>
                    {description}
                </Text>
            )}
        </>
    );
}
